import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import {          
         User,
         Room,
         Date,
         Time,
         DateTimeFrame,
         ApiService,
         LocalStorageService,
         SnackbarService,
         Conference,
         CONFERENCE_TYPES,
         TimelineCounts,
} from '../../../shared';
import { Observable } from 'rxjs';


@Component({
  selector: 'app-hunt-page',
  templateUrl: './hunt-page.component.html',
  styleUrls: ['./hunt-page.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class HuntPageComponent implements OnInit {
  title: string;
  subtitle: string;
  selectedTabIndex: number;
  currentClusterName: string;
  
  possibleConference: Conference;
  huntPreferences$: Observable<DateTimeFrame>;
  timelineCounts: TimelineCounts;

  user: User;
  availableRooms: Room[];
  bookingResponse$: Observable<Conference>;

  constructor(
    private apiService: ApiService,
    private storageService: LocalStorageService,
    private snackBarService: SnackbarService,
  ) {}

  ngOnInit() {
    this.getMe();
    this.huntPreferences$ = this.getHuntPreferences()
    this.getCurrentClusterName()
    this.initHuntFormTab()
  }

  initHuntFormTab() {
    this.selectedTabIndex = 0
    this.title = 'hunt for spot';
    this.subtitle = 'pick date and time'
  }

  initAvailableRoomsTab() {
    this.selectedTabIndex = 1
    this.title = 'free spots';
    let start = this.possibleConference.timelines[0].start;
    let finish = this.possibleConference.timelines[this.possibleConference.timelines.length - 1].finish
    this.subtitle = `on ${this.possibleConference.date.month}/${this.possibleConference.date.day} from` +
      ` ${new Time(start.hour, start.minute).toEastern()} to ${ new Time(finish.hour, finish.minute).toEastern()}`;
  }

  initConfirmationTab() {
    this.selectedTabIndex = 2
    this.title = 'confirmation';
    this.subtitle = 'you\'re almost there'
  }

  initBookingStatusTab() {
    this.selectedTabIndex = 3
    this.title = 'booking status';
    this.subtitle = 'lets see how it went'
  }

  getCurrentClusterName(): void {
    this.storageService.getClusterName()
      .subscribe(clusterName => this.currentClusterName = clusterName);
  }

  getMe() {
    this.apiService.getMe()
      .subscribe(me => this.user = me);
  }

  getHuntPreferences() {
    return this.apiService.getDateTimeFrame();
  }

  handleDatePick(date: Date) {
    this.apiService.getMyTimelineCounts(date)
      .subscribe(myTimelineCounts => {
        this.timelineCounts = new TimelineCounts(myTimelineCounts.solid, myTimelineCounts.iffy);
        if (this.timelineCounts.allowed == 0) {
          this.snackBarService.showNotifation('no more conferences for the selected date, you\'ve used all available hours');
        }
      })
  }

  handleSearch(possibleConference: Conference) {
    this.possibleConference = possibleConference;
    this.possibleConference.reservator = this.user;
    this.possibleConference.type = this.timelineCounts.solid > 0 ? CONFERENCE_TYPES.SOLID : CONFERENCE_TYPES.IFFY;
    this.apiService.getAvailableRooms(possibleConference, this.currentClusterName)
      .subscribe(availableRooms => {
        this.availableRooms = availableRooms;
        this.initAvailableRoomsTab();
      });
  }

  handleRoomPick(room: Room) {
    this.possibleConference.room = room;
    this.initConfirmationTab();
  }

  handleConferenceConfirmed(notifyTeam: boolean) {
    this.bookingResponse$ = this.apiService.bookConference(this.possibleConference, notifyTeam);
    this.initBookingStatusTab()        
  }

  onBack() {
    switch(this.selectedTabIndex - 1) {
      case 0:
        this.initHuntFormTab();
        break;
      case 1:
        this.initAvailableRoomsTab();
        break;
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/hunt/pages/hunt-page/hunt-page.component.ts